/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TicketEventDetail } from './TicketEventDetail';
import {
    TicketEventDetailFromJSON,
    TicketEventDetailFromJSONTyped,
    TicketEventDetailToJSON,
    TicketEventDetailToJSONTyped,
} from './TicketEventDetail';

/**
 * 
 * @export
 * @interface ResultOfTicketEventDetail
 */
export interface ResultOfTicketEventDetail {
    /**
     * 
     * @type {TicketEventDetail}
     * @memberof ResultOfTicketEventDetail
     */
    data: TicketEventDetail | null;
    /**
     * 
     * @type {boolean}
     * @memberof ResultOfTicketEventDetail
     */
    isSuccess: boolean;
    /**
     * 
     * @type {Error}
     * @memberof ResultOfTicketEventDetail
     */
    error: Error | null;
}

/**
 * Check if a given object implements the ResultOfTicketEventDetail interface.
 */
export function instanceOfResultOfTicketEventDetail(value: object): value is ResultOfTicketEventDetail {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('isSuccess' in value) || value['isSuccess'] === undefined) return false;
    if (!('error' in value) || value['error'] === undefined) return false;
    return true;
}

export function ResultOfTicketEventDetailFromJSON(json: any): ResultOfTicketEventDetail {
    return ResultOfTicketEventDetailFromJSONTyped(json, false);
}

export function ResultOfTicketEventDetailFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfTicketEventDetail {
    if (json == null) {
        return json;
    }
    return {
        
        'data': TicketEventDetailFromJSON(json['data']),
        'isSuccess': json['isSuccess'],
        'error': json['error'],
    };
}

export function ResultOfTicketEventDetailToJSON(json: any): ResultOfTicketEventDetail {
    return ResultOfTicketEventDetailToJSONTyped(json, false);
}

export function ResultOfTicketEventDetailToJSONTyped(value?: ResultOfTicketEventDetail | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': TicketEventDetailToJSON(value['data']),
        'isSuccess': value['isSuccess'],
        'error': value['error'],
    };
}

